/* eslint-disable react/forbid-elements */
import * as React from 'react';

import { ChatMessageLoader } from '../../../components/ChatMessageLoader';
import { EOutcomingStatus, TOutcomingStatus } from '../../../types/messages';

export const getStatusIcon = (status: TOutcomingStatus | null): React.ReactNode => {
  switch (status) {
    case EOutcomingStatus.Read:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-testid="read_status"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8428 5L8 10.8428L8.70711 11.5499L14.5499 5.70711L13.8428 5ZM2 8.08433L2.68233 7.35328L5.74027 10.2074L10.854 5.00007L11.5675 5.70073L5.77067 11.6037L2 8.08433Z"
            fill="currentColor"
          />
        </svg>
      );
    case EOutcomingStatus.Fulfilled:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          data-testid="fullfilled_status"
        >
          <path
            d="M2.68233 7.35322L2 8.08426L5.77067 11.6036L11.5675 5.70067L10.854 5L5.74027 10.2074L2.68233 7.35322Z"
            fill="currentColor"
          />
        </svg>
      );
    case EOutcomingStatus.Failed:
      return null;
    default:
      return <ChatMessageLoader data-testid="loader" />;
  }
};
